import * as d3 from "d3";
import {axisTextDim2, responsivefy} from '../functions'

export default function (chart, divId, vizName, resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var renameKeys = function (obj) {
        /*Recursively renames "key" keys to "name" and
        renames "values" keys to "children" */
        obj.name = obj.key;
        delete obj.key;
        if (obj.values) {
            obj.children = obj.values;
            delete obj.values;
            obj.children.forEach(renameKeys);
        }
        return obj;
    };

    // axios.post(url, filterParam).then(res => {
        let data = resData

        var nest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim2_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim3_name;
            }).sortKeys(d3.ascending)
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.metric1;
                })
            })
            .entries(data);

        var flareData = {key: 'ffm', values: []};
        flareData.values = nest;
        renameKeys(flareData);

        (function visualize() {
            var x1Scale = d3.scaleLinear().range([0, chart.width]);
            var barHeight = 20;

            var metric1ColorScale = d3.scaleOrdinal().range(["steelblue", "#ccc"]);

            var duration = 750, delay = 25;

            var partition = d3.partition();

            var x1AxisLabel = d3.axisTop().scale(x1Scale);

            var svg = d3.select(divId).select("svg").remove();
            svg = d3.select(divId).append("svg")
                .attr("width", chart.width + chart.margin.left + chart.margin.right)
                .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                .call(responsivefy)
                .append("g")
                .attr("transform", "translate(" + 2 * chart.margin.left + "," + chart.margin.top + ")");

            svg.append("rect")
                .attr("class", "background")
                .attr("width", chart.width)
                .attr("height", chart.height)
                .on("click", up)
                .style("fill", "white")

            svg.append("g").attr("class", "x axis");

            svg.append("g")
                .attr("class", "y axis")
                .append("line")
                .attr("y1", "100%")
                .style("stroke", "black")

            var root = d3.hierarchy(flareData).sum(d => d.value)
                .sort((a, b) => b.value - a.value);

            partition(root);

            x1Scale.domain([0, root.value]).nice();
            down(root, 0);

            function down(d, i) {
                var end = duration + d.children.length * delay;

                // Mark any currently-displayed bars as exiting.
                var exit = svg.selectAll(".enter").attr("class", "exit");

                // Entering nodes immediately obscure the clicked-on bar, so hide it.
                exit.selectAll("rect")
                    .filter(function (p) {
                        return p === d;
                    })
                    .style("fill-opacity", 1e-6);

                // Enter the new bars for the clicked-on data.
                // Per above, entering bars are immediately visible.
                var enter = bar(d).attr("transform", stack(i)).style("opacity", 1);

                // Have the text fade-in, even though the bars are visible.
                // Color the bars as parents; they will fade to children if appropriate.
                enter.select("text").style("fill-opacity", 1e-6);
                enter.select("rect").style("fill", metric1ColorScale(true));

                // Update the x-scale domain.
                x1Scale.domain([0, d3.max(d.children, (d) => {
                    return d.value;
                })]).nice();

                // Update the x-axis.
                svg.selectAll(".x.axis")
                    .transition()
                    .duration(duration)
                    .call(x1AxisLabel)
                    .style("font-size", "15px");

                // Transition entering bars to their new position.
                var enterTransition = enter.transition()
                    .duration(duration)
                    .delay((d, i) => {
                        return i * delay;
                    })
                    .attr("transform", (d, i) => {
                        return "translate(0," + barHeight * i * 1.2 + ")"
                    });

                // Transition entering text.
                enterTransition.select("text").style("fill-opacity", 1);

                // Transition entering rects to the new x-scale.
                enterTransition.select("rect")
                    .attr("width", (d) => {
                        return x1Scale(d.value);
                    })
                    .style("fill", (d) => {
                        return metric1ColorScale(!!d.children);
                    })

                // Transition exiting bars to fade out.
                var exitTransition = exit.transition()
                    .duration(duration)
                    .style("opacity", 1e-6)
                    .remove();

                // Transition exiting bars to the new x-scale.
                exitTransition.selectAll("rect")
                    .attr("width", (d) => {
                        return x1Scale(d.value)
                    });

                // Rebind the current node to the background.
                svg.select(".background")
                    .datum(d)
                    .transition()
                    .duration(end);

                d.index = i;
            }

            function up(d) {
                if (!d.parent || this.__transition__) return;
                var end = duration + d.children.length * delay;

                // Mark any currently-displayed bars as exiting.
                var exit = svg.selectAll(".enter").attr("class", "exit");

                // Enter the new bars for the clicked-on data's parent.
                var enter = bar(d.parent)
                    .attr("transform", (d, i) => {
                        return "translate(0," + barHeight * i * 1.2 + ")"
                    })
                    .style("opacity", 1e-6);

                // Color the bars as appropriate.
                // Exiting nodes will obscure the parent bar, so hide it.
                enter.select("rect")
                    .style("fill", function (d) {
                        return metric1ColorScale(!!d.children)
                    })
                    .filter(function (p) {
                        return p === d
                    })
                    .style("fill-opacity", 1e-6);

                // Update the x-scale domain.
                x1Scale.domain([0, d3.max(d.parent.children, function (d) {
                    return d.value;
                })]).nice();

                // Update the x-axis.
                svg.selectAll(".x.axis").transition()
                    .duration(duration)
                    .call(x1AxisLabel);

                // Transition entering bars to fade in over the full duration.
                var enterTransition = enter.transition()
                    .duration(end)
                    .style("opacity", 1);

                // Transition entering rects to the new x-scale.
                // When the entering parent rect is done, make it visible!
                enterTransition.select("rect")
                    .attr("width", (d) => {
                        return x1Scale(d.value)
                    })
                    .on("end", function (p) {
                        if (p === d) d3.select(this).style("fill-opacity", null);
                    });

                // Transition exiting bars to the parent's position.
                var exitTransition = exit.selectAll("g").transition()
                    .duration(duration)
                    .delay(function (d, i) {
                        return i * delay
                    })
                    .attr("transform", stack(d.index));

                // Transition exiting text to fade out.
                exitTransition.select("text")
                    .style("fill-opacity", 1e-6);

                // Transition exiting rects to the new scale and fade to parent color.
                exitTransition.select("rect")
                    .attr("width", (d) => {
                        return x1Scale(d.value)
                    })
                    .style("fill", metric1ColorScale(true));

                // Remove exiting nodes when the last child has finished transitioning.
                exit.transition().duration(end).remove();

                // Rebind the current parent to the background.
                svg.select(".background")
                    .datum(d.parent)
                    .transition()
                    .duration(end);
            }

            // Creates a set of bars for the given data node, at the specified index.
            function bar(d) {
                var bar = svg.insert("g", ".y.axis")
                    .attr("class", "enter")
                    .attr("transform", "translate(0,5)")
                    .selectAll("g")
                    .data(d.children)
                    .enter().append("g")
                    .style("cursor", (d) => {
                        return !d.children ? null : "pointer"
                    })
                    .on("click", down)
                //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

                bar.append("text")
                    .attr("x", -6)
                    .attr("y", barHeight / 2)
                    .attr("dy", ".35em")
                    .attr("dx", "-10em")
                    .style("text-anchor", "start")
                    .text(axisTextDim2);

                bar.append("rect")
                    .attr("width", (d) => {
                        return x1Scale(d.value);
                    })
                    .attr("height", barHeight);

                return bar;
            }

            // A stateful closure for stacking bars horizontally.
            function stack(i) {
                var x0 = 0;
                return function (d) {
                    var tx = "translate(" + x0 + "," + barHeight * i * 1.2 + ")";
                    x0 += x1Scale(d.value);
                    return tx;
                };
            }
        })(flareData);
    // });
}
